import {
  BooleanInput,
  Edit,
  NumberInput,
  SimpleForm,
  TextInput,
  maxLength,
  minLength,
  regex,
  required,
  useRecordContext,
} from 'react-admin';

import { AdminGetUserResponseDto } from 'api/generated';
import { useState } from 'react';

const UsersEdit = () => {
  const validateNickname = [
    required(),
    minLength(2),
    maxLength(25),
    regex(
      // eslint-disable-next-line no-useless-escape
      /^[a-zA-Z0-9_][a-zA-Z0-9_\.]*$/,
      'Никнейм может содержать латинские буквы, цифры, символ нижнего подчеркивания и точку',
    ),
  ];

  const VerifyedUserBlock = () => {
    const record = useRecordContext<AdminGetUserResponseDto>();
    const [showPriorityInput, setShowPriorityInput] = useState<boolean>(record.profile.verified);

    return (
      <>
        <BooleanInput
          label="Галочка"
          source="profile.verified"
          defaultValue={record.profile.verified}
          onChange={() => setShowPriorityInput(!showPriorityInput)}
        />
        {showPriorityInput && <NumberInput label="Приоритет профиля" source="profile.priority" />}
      </>
    );
  };

  return (
    <Edit title="Изменение профиля пользователя">
      <SimpleForm>
        <TextInput label="Никнейм" source="nickname" validate={validateNickname} />
        <VerifyedUserBlock />
      </SimpleForm>
    </Edit>
  );
};

export default UsersEdit;
